/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_EventsInputs */

const en_nav_events = /** @type {(inputs: Nav_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Events`)
};

const es_nav_events = /** @type {(inputs: Nav_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eventos`)
};

const de_nav_events = /** @type {(inputs: Nav_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veranstaltungen`)
};

const zh_nav_events = /** @type {(inputs: Nav_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`活动`)
};

const ar_nav_events = /** @type {(inputs: Nav_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الفعاليات`)
};

const fr_nav_events = /** @type {(inputs: Nav_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Événements`)
};

const vi_nav_events = /** @type {(inputs: Nav_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sự kiện`)
};

const sw_nav_events = /** @type {(inputs: Nav_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matukio`)
};

const th_nav_events = /** @type {(inputs: Nav_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กิจกรรม`)
};

const bs_nav_events = /** @type {(inputs: Nav_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Događaji`)
};

const ja_nav_events = /** @type {(inputs: Nav_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベント`)
};

const ko_nav_events = /** @type {(inputs: Nav_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이벤트`)
};

const pt_nav_events = /** @type {(inputs: Nav_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eventos`)
};

const it_nav_events = /** @type {(inputs: Nav_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eventi`)
};

const sv_nav_events = /** @type {(inputs: Nav_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evenemang`)
};

const nl_nav_events = /** @type {(inputs: Nav_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evenementen`)
};

const da_nav_events = /** @type {(inputs: Nav_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arrangementer`)
};

const nb_nav_events = /** @type {(inputs: Nav_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arrangementer`)
};

const fi_nav_events = /** @type {(inputs: Nav_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tapahtumat`)
};

const pl_nav_events = /** @type {(inputs: Nav_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wydarzenia`)
};

const ru_nav_events = /** @type {(inputs: Nav_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Мероприятия`)
};

const tr_nav_events = /** @type {(inputs: Nav_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etkinlikler`)
};

const hi_nav_events = /** @type {(inputs: Nav_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कार्यक्रम`)
};

const id_nav_events = /** @type {(inputs: Nav_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acara`)
};

const ms_nav_events = /** @type {(inputs: Nav_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acara`)
};

const cs_nav_events = /** @type {(inputs: Nav_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akce`)
};

const el_nav_events = /** @type {(inputs: Nav_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Εκδηλώσεις`)
};

const he_nav_events = /** @type {(inputs: Nav_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`אירועים`)
};

const af_nav_events = /** @type {(inputs: Nav_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geleenthede`)
};

const hu_nav_events = /** @type {(inputs: Nav_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Események`)
};

/**
* | output |
* | --- |
* | "Events" |
*
* @param {Nav_EventsInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const nav_events = /** @type {((inputs?: Nav_EventsInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_EventsInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_nav_events(inputs)
	if (locale === "de") return de_nav_events(inputs)
	if (locale === "zh") return zh_nav_events(inputs)
	if (locale === "ar") return ar_nav_events(inputs)
	if (locale === "fr") return fr_nav_events(inputs)
	if (locale === "vi") return vi_nav_events(inputs)
	if (locale === "sw") return sw_nav_events(inputs)
	if (locale === "th") return th_nav_events(inputs)
	if (locale === "bs") return bs_nav_events(inputs)
	if (locale === "ja") return ja_nav_events(inputs)
	if (locale === "ko") return ko_nav_events(inputs)
	if (locale === "pt") return pt_nav_events(inputs)
	if (locale === "it") return it_nav_events(inputs)
	if (locale === "sv") return sv_nav_events(inputs)
	if (locale === "nl") return nl_nav_events(inputs)
	if (locale === "da") return da_nav_events(inputs)
	if (locale === "nb") return nb_nav_events(inputs)
	if (locale === "fi") return fi_nav_events(inputs)
	if (locale === "pl") return pl_nav_events(inputs)
	if (locale === "ru") return ru_nav_events(inputs)
	if (locale === "tr") return tr_nav_events(inputs)
	if (locale === "hi") return hi_nav_events(inputs)
	if (locale === "id") return id_nav_events(inputs)
	if (locale === "ms") return ms_nav_events(inputs)
	if (locale === "cs") return cs_nav_events(inputs)
	if (locale === "el") return el_nav_events(inputs)
	if (locale === "he") return he_nav_events(inputs)
	if (locale === "af") return af_nav_events(inputs)
	if (locale === "hu") return hu_nav_events(inputs)
	return en_nav_events(inputs)
});